<figure class='highcharts-figure'>
  <div id="{{chartName}}"></div>
</figure>